module.exports = __webpack_public_path__ + "static/img/empty.a9c8e303.jpg";